export const CHANGE_CONTACT_EMAIL = "contact/change_contact_email";
export const CHANGE_CONTACT_TITLE = "contact/change_contact_title";
export const CHANGE_CONTACT_CONTENT = "contact/change_contact_content";
